// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__Ji9mG","shimmer":"Skeleton_shimmer__Ozz6q","circle":"Skeleton_circle__Y5t58"};